export default {
    common: 'COMMON',
    installment: 'INSTALLMENT',
    thankPage: 'THANK_PAGE',
};
